import type { SiteConfig } from '@/types'

export const siteConfig: SiteConfig = {
    name: 'WellPath Fusion',
    description:
        'Evidence-aware wellness for the whole person. Practical guidance on holistic health, lifestyle balance, and mind-body practices you can actually live with.',
    url: 'https://wellpathfusion.com',
    ogImage: '/og.png',
    locale: 'en_US'
}
